import React from "react";
import { useBuilder, BlockConfig } from "../BuilderContext";

const fmt = (cents: number) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(cents / 100);

const PerMatterBreakdownBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state } = useBuilder();
  const heading = block.settings.headingOverride || "Per-Matter Breakdown";

  if (!state.matterBreakdowns || state.matterBreakdowns.length === 0) {
    return (
      <div className="py-4">
        <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">{heading}</p>
        <p className="text-sm text-slate-400 text-center py-4">No matter breakdown available</p>
      </div>
    );
  }

  return (
    <div className="py-4">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">{heading}</p>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b-2" style={{ borderColor: "var(--color-primary)" }}>
            <th className="text-left py-2 text-xs font-semibold text-slate-600">Matter</th>
            <th className="text-right py-2 text-xs font-semibold text-slate-600">Invoiced</th>
            <th className="text-right py-2 text-xs font-semibold text-slate-600">Paid</th>
            <th className="text-right py-2 text-xs font-semibold text-slate-600">Outstanding</th>
          </tr>
        </thead>
        <tbody>
          {state.matterBreakdowns.map((mb: any, i: number) => (
            <tr key={mb.matterId || i} className="border-b border-slate-100">
              <td className="py-2 text-slate-800 font-medium">{mb.matterTitle || "Unknown"}</td>
              <td className="py-2 text-right text-slate-800">{fmt(mb.invoicedCents)}</td>
              <td className="py-2 text-right text-emerald-700">{fmt(mb.paidCents)}</td>
              <td className="py-2 text-right font-medium text-slate-800">{fmt(mb.outstandingCents)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PerMatterBreakdownBlock;
